module.exports = __webpack_public_path__ + "static/media/arrow.d4311843.svg";